import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FiImageSize } from '@fi-shared/types';

@Component({
    selector: 'fi-task-v2-attachments-short',
    templateUrl: './fi-task-v2-attachments-short.component.html',
    styleUrls: ['./fi-task-v2-attachments-short.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-attachments-short' },
    standalone: false,
})
export class FiTaskV2AttachmentsShortComponent {
    @Input({ required: true }) mediaBankFileReferences: IMediaBankFileReference[] = [];
    protected readonly FiImageSize = FiImageSize;

    @HostBinding('class.hidden') private get isHidden(): boolean {
        return !this.mediaBankFileReferences?.length;
    }

    @HostBinding('class.unlimited-attachment-size') @Input() unlimitedAttachmentSize: boolean = false;
}
